import * as tslib_1 from "tslib";
import getItemTailoredXpData from './getItemTailoredXpData';
import getErrorResponseCode from '../utils/getErrorResponseCode';
import initializeUndefinedItemProperties from '../utils/initializeUndefinedItemProperties';
import isActionSourcePrefetch from '../utils/isActionSourcePrefetch';
import preserveItemDataInCache from '../utils/preserveItemDataInCache';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { getItem, checkIfResponseSuccess, mailStore, getBaseItemResponseShape, } from 'owa-mail-store';
var assign = require('object-assign');
function parseItemResponse(responseItem, itemId) {
    var cachedItem = mailStore.items.get(itemId.Id);
    if (cachedItem) {
        // If the item already exists in the cache, make sure we preserve any data missing on the response item
        preserveItemDataInCache(responseItem, cachedItem);
    }
    // Initialize required properties that could be undefined so they're observable in the store.
    initializeUndefinedItemProperties(responseItem);
    mailStore.items.set(itemId.Id, tslib_1.__assign({}, responseItem, { MailboxInfo: itemId.mailboxInfo, SmartReplyData: null, SmartTimeData: null, AttachmentSuggestions: null, smartPillFeedbackSubmitted: false }));
    // Use the item reference from the store (http://aka.ms/mobx4)
    getItemTailoredXpData(mailStore.items.get(itemId.Id));
}
var parseItemResponseAction = action('parseItemResponse')(parseItemResponse);
export function loadItem(itemIdToLoad, actionSource, topActionDatapoint) {
    var requestStartTime;
    if (topActionDatapoint) {
        requestStartTime = topActionDatapoint.addCheckmark('request_start');
    }
    // Add action source to the request header 'X-OWA-ActionSource' for diagnostic
    var options = {};
    assign(options, itemIdToLoad.mailboxInfo && itemIdToLoad.mailboxInfo.requestOptions);
    if (options && options.headers) {
        var headers = new Headers(options.headers);
        headers.set('X-OWA-ActionSource', actionSource);
        options.headers = headers;
    }
    return getItem([itemIdToLoad.Id], getBaseItemResponseShape(), 'ItemNormalizedBody', 'V2017_08_18' /* requestServerVersion */, options)
        .then(function (responseMessage) {
        // Add the request time as the custom data.
        if (topActionDatapoint) {
            var requestEndTime = topActionDatapoint.addCheckmark('request_end');
            topActionDatapoint.addCustomData({
                requestTime: requestEndTime - requestStartTime,
            });
        }
        if (checkIfResponseSuccess(responseMessage[0])) {
            var response = responseMessage[0];
            parseItemResponseAction(response.Items[0], itemIdToLoad);
            return mailStore.items.get(itemIdToLoad.Id);
        }
        else {
            switch (actionSource) {
                case 'PrefetchFirstN':
                case 'PrefetchSingleRow':
                case 'PrefetchRowInCache':
                case 'PrefetchAjacentItemsOnDelay':
                    break;
                case 'LoadItemReadingPane':
                case 'LoadItemPreviewPane':
                default:
                    trace.warn(actionSource + ': ' + responseMessage[0].MessageText);
                    break;
            }
            var _a = tslib_1.__read(getErrorResponseCode(responseMessage[0]), 2), errorResponseCode = _a[0], stackTrace = _a[1];
            if (errorResponseCode) {
                return Promise.reject(new Error("ErrorResponseCode=" + errorResponseCode + ", StackTrace=" + stackTrace));
            }
            else {
                return Promise.resolve(null);
            }
        }
    })
        .catch(function (error) {
        // Add the action source to the error message
        error.message += ", ActionSource=" + actionSource;
        // If the action source is not prefetch, reject the error.
        if (!isActionSourcePrefetch(actionSource)) {
            return Promise.reject(error);
        }
        else {
            return Promise.resolve();
        }
    });
}
//# sourceMappingURL=loadItem.js.map